__webpack_require__.p = "https://pestalozzi11.de/konfigurator/";